import { FulfilmentMethodTrackingData, trackPickupWarehouseChange, trackShippingMethod } from "@DSG/Common/DSGTracking";
import ApplicationStateDSG from "@DSG/Store/DSGState";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";

import {
    chain,
    DispatchCompleteLoadSession,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type SetFulfillmentMethodParameters = Parameters<typeof PopulateApiParameter>[0];

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
addToChainAfter(chain, DispatchCompleteLoadSession, DispatchCompleteLoadSessionExt);
function DispatchCompleteLoadSessionExt(props: SetFulfillmentMethodParameters) {
    const state = props.getState();
    const fulfilMentMethodChange = {
        event: "form_submit",
        form_action: "submit",
        form_category: "preferences",
        form_name: "fulfillment options",
        form_type: "settings",
        form_selections: [
            {
                form_field_name: "fulfillment option",
                form_field_value: props.parameter.fulfillmentMethod,
            },
            {
                form_field_name: "pickup branch location",
                form_field_value: state.context.session?.pickUpWarehouse?.description,
            },
        ],
    } as FulfilmentMethodTrackingData;

    trackPickupWarehouseChange(fulfilMentMethodChange);
    const currentPage = getCurrentPage(state);

    if (currentPage.type === "OnePageCheckoutPage") {
        const customState = props.getState() as ApplicationStateDSG;

        const cart = getCurrentCartState(state).value;
        if (cart) {
            trackShippingMethod(cart, customState);
        }
    }
}
